import { Grid2 } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import {
  AlarmCentralPhysicalContext,
  IAlarmCentralProblemsProps,
} from '../../context/AlarmCentralPhysicalContext';
import AlarmCentralHeaderActionContainer from '../_components/AlarmCentralHeaderActionContainer';
import { Lock } from '@mui/icons-material';
import AlarmCentralResume from '../_components/AlarmCentralResumeCard';
import { useArmPhysicalByPartitionAlarmCentral } from '../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import AlarmCentralEventsList from '../_components/AlarmCentralEventsList';
import { IAlarmCentralEventProps } from '../../../../services/AlarmCentralService/Virtual/types';
import AlarmCentralPhysicalJflPartitions from './_components/AlarmCentralPhysicalJflPartitions';
import AlarmCentralPhysicalIntelbrasPartitions from './_components/AlarmCentralPhysicalIntelbrasPartitions';
import AlarmCentralPhysicalVettiPartitions from './_components/AlarmCentralPhysicalVettiPartitions';
import AlarmCentralPhysicalJflZones from './_components/AlarmCentralPhysicalJflZones';
import AlarmCentralPhysicalJflPgms from './_components/AlarmCentralPhysicalJflPgms';
import CardComponent from '../../../../components/CardComponent/CardComponent';
import { IAlarmCentralJflStatusProps } from '../../../../services/AlarmCentralService/Physical/Jfl/types';
import AlarmCentralPhysicalVettiPgms from './_components/AlarmCentralPhysicalVettiPgms';
import AlarmCentralPhysicalVettiZones from './_components/AlarmCentralPhysicalVettiZones';
import AlarmCentralPhysicalIntelbrasZones from './_components/AlarmCentralPhysicalIntelbrasZones';
import AlarmCentralPhysicalIntelbrasPgms from './_components/AlarmCentralPhysicalIntelbrasPgms';

const AlarmCentralManagementPhysicalPage = () => {
  const { alarmCentral, problems } = useContext(AlarmCentralPhysicalContext);
  const [lastEvent, setLastEvent] = useState<
    IAlarmCentralEventProps | undefined
  >(undefined);
  const { mutateAsync: armPhysicalByPartitionAlarmCentral } =
    useArmPhysicalByPartitionAlarmCentral();

  const renderPartitionButton = () => {
    if (!alarmCentral) return <></>;

    switch (alarmCentral.company) {
      case 'JFL':
        return (
          <AlarmCentralPhysicalJflPartitions
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      case 'INTELBRAS':
        return (
          <AlarmCentralPhysicalIntelbrasPartitions
            alarmCentral={alarmCentral}
            status={alarmCentral.status}
          />
        );
      case 'VETTI':
        return (
          <AlarmCentralPhysicalVettiPartitions
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      default:
        return <></>;
    }
  };

  const renderZone = () => {
    if (!alarmCentral) return <></>;

    switch (alarmCentral.company) {
      case 'JFL':
        return (
          <AlarmCentralPhysicalJflZones
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      case 'INTELBRAS':
        return (
          <AlarmCentralPhysicalIntelbrasZones
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      case 'VETTI':
        return (
          <AlarmCentralPhysicalVettiZones
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      default:
        return <></>;
    }
  };

  const renderPgms = () => {
    if (!alarmCentral) return <></>;

    switch (alarmCentral.company) {
      case 'JFL':
        return (
          <AlarmCentralPhysicalJflPgms
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      case 'INTELBRAS':
        return (
          <AlarmCentralPhysicalIntelbrasPgms
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      case 'VETTI':
        return (
          <AlarmCentralPhysicalVettiPgms
            status={alarmCentral.status}
            alarmCentral={alarmCentral}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <Grid2 container columnSpacing={2}>
      <AlarmCentralHeaderActionContainer
        name={alarmCentral.name}
        iconArmOrDisarmButton={<Lock />}
        onClickArmOrDisarmButton={() => {}}
        isLoadingArmOrDisarmCompleteAlarmCentral={false}
        isTotalArmed={false}
        shieldColor={'success'}
        statusTextColor={'success'}
      />

      <AlarmCentralResume
        name={alarmCentral.name}
        isVirtual={false}
        alarmCentral={alarmCentral}
        isWithProblems={problems.length > 0}
        lastEventDate={lastEvent?.createdAt}
        isConnected={alarmCentral.isConnected}
      />

      <Grid2 size={{ xs: 12, xl: 8 }} container>
        <Grid2 size={{ xs: 12, xl: 6 }} sx={{ mt: 2 }}>
          <CardComponent title={'PARTIÇÕES'}>
            <Grid2
              container
              columnSpacing={2}
              rowSpacing={1}
              sx={{ overflowY: 'scroll', maxHeight: '300px', pr: 2 }}
            >
              {alarmCentral && renderPartitionButton()}
            </Grid2>
          </CardComponent>
        </Grid2>

        <Grid2 size={{ xs: 12, xl: 6 }} sx={{ mt: 2 }}>
          <CardComponent title={'ZONAS'}>
            <Grid2
              container
              columnSpacing={2}
              rowSpacing={1}
              sx={{ overflowY: 'scroll', maxHeight: '300px', pr: 2 }}
            >
              {alarmCentral && renderZone()}
            </Grid2>
          </CardComponent>
        </Grid2>
        <Grid2 size={{ xs: 12 }} sx={{ mt: 2 }}>
          <CardComponent title={'PGMS'}>
            {alarmCentral && renderPgms()}
          </CardComponent>
        </Grid2>
      </Grid2>

      <AlarmCentralEventsList
        onGetLastEvent={(evt) => setLastEvent(evt)}
        alarmCentral={alarmCentral}
      />
    </Grid2>
  );
};

export default AlarmCentralManagementPhysicalPage;
